import { jsx as o } from "react/jsx-runtime";
import e from "clsx";
import { CardHeader as c } from "../../Card/Header/CardHeader.js";
import { ButtonIcon as p } from "../../ButtonIcon/ButtonIcon.js";
import { IconCaret as d } from "../../Icons/index.js";
const x = ({
  buttonAriaLabel: t,
  className: a,
  noBorder: n,
  _buttonAriaControls: i,
  _buttonOnClick: l,
  _isExpanded: r,
  _onClick: m,
  ...s
}) => /* @__PURE__ */ o(
  c,
  {
    className: e(
      "group/button",
      // For `ButtonIcon` with `enableGroupHover`
      "cursor-pointer",
      "select-none",
      a
    ),
    noBorder: n || !r,
    onClick: m,
    slotEnd: /* @__PURE__ */ o(
      p,
      {
        ariaControls: i,
        ariaExpanded: r,
        ariaLabel: t,
        enableGroupHover: !0,
        onClick: l,
        size: "sm",
        variant: "text",
        children: /* @__PURE__ */ o(
          d,
          {
            className: e({ "rotate-180": r }),
            size: "md",
            variant: "down"
          }
        )
      }
    ),
    ...s
  }
);
export {
  x as CollapsibleCardHeader
};
